// Replaces $(document).ready()
document.addEventListener('DOMContentLoaded', function() {

  console.log('Plain JS is ready');

  // --- Find Elements ---

  // Find all elements with the class '.openregis'
  const openButtons = document.querySelectorAll('.openregis');
  
  // Find the single popup wrapper element
  const popupWrapper = document.querySelector('.wrapperpopup');

  // **NEW: Find all elements with the class '.cancelbtn'**
  const cancelButtons = document.querySelectorAll('.cancelbtn');


  // --- Open Popup Logic ---

  // Loop over all the 'open' buttons
  openButtons.forEach(function(button) {
    
    // Add the click listener to each 'open' button
    button.addEventListener('click', function(event) {
      
      // Prevent default click behavior
      event.preventDefault();
      
      if (popupWrapper) {
        // Add the 'active' class to show the popup
        popupWrapper.classList.add('active');
      } else {
        console.warn('Could not find .wrapperpopup to open.');
      }
    });
  });

  
  // --- **NEW: Close Popup Logic** ---

  // Loop over all the 'cancel' buttons
  cancelButtons.forEach(function(button) {

    // Add the click listener to each 'cancel' button
    button.addEventListener('click', function(event) {

      // Prevent default click behavior
      event.preventDefault();

      if (popupWrapper) {
        // **Remove the 'active' class to hide the popup**
        popupWrapper.classList.remove('active');
      } else {
        console.warn('Could not find .wrapperpopup to close.');
      }
    });
  });

});